<template>
  <div class="about content">
    <Head ref="goTop" />
    <section class="header-box">
      <div class="header-inner">
        <span>Welcome to</span>
        <h1>Amei's home</h1>
        <div style="height: 65px;">
            <h6>{{ content.substr(0, count) }}</h6>
            <span class="typed-cursor">|</span>
        </div>
        <div class="scroll-down">
          <span></span>
        </div>
      </div>
    </section>
    <section class="team-box">
      <div class="about-container">
        <div class="about-container-head center">
          <h2>My Team Members</h2>
          <p>Leo:Java Engineer & Virgo:Web Developer</p>
        </div>
        <div class="about-container-content clearfix">
          <div class="left two center">
            <div class="team-member">
              <img src="../assets/about/team-1.png" alt="">
            </div>
            <div class="center">
              <h4>Leo</h4>
              <span class="font-14">Java Engineer</span>
              <ul>
                <li><a href="javascript:void(0);"><i class="el-icon-star-on"></i></a></li>
                <li><a href="javascript:void(0);"><i class="el-icon-star-on"></i></a></li>
                <li><a href="javascript:void(0);"><i class="el-icon-star-on"></i></a></li>
                <li><a href="javascript:void(0);"><i class="el-icon-star-on"></i></a></li>
              </ul>
            </div>
          </div>
          <div class="left two center">
            <div class="team-member">
              <img src="../assets/about/team-2.png" alt="">
            </div>
            <div class="center">
              <h4>Virgo</h4>
              <span class="font-14">Web Developer</span>
              <ul>
                <li><a href="javascript:void(0);"><i class="el-icon-star-on"></i></a></li>
                <li><a href="javascript:void(0);"><i class="el-icon-star-on"></i></a></li>
                <li><a href="javascript:void(0);"><i class="el-icon-star-on"></i></a></li>
                <li><a href="javascript:void(0);"><i class="el-icon-star-on"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="resome-box">
      <div class="about-container">
        <div class="about-container-head center">
          <h2>Education & Experience</h2>
          <p>Simple Introduce for Leo & Virgo</p>
        </div>
        <div class="about-container-content clearfix">
          <div class="left two">
            <div class="resome-detail">
              <div class="icon">
                <i class="el-icon-star-on"></i>
              </div>
              <div class="resome-list">
                <h4>BOHAI University</h4>
                <span>2011 - 2015</span>
                <p>Computer Science and Technology.</p>
              </div>
              <div class="resome-list">
                <h4>Java Engineer</h4>
                <span>2014 - Now</span>
                <p>Spring, Mybatis, Linux, Redis, MQ, Nginx, Alibaba Cloud.</p>
              </div>
            </div>
          </div>
          <div class="left two">
            <div class="resome-detail">
              <div class="icon">
                <i class="el-icon-star-on"></i>
              </div>
              <div class="resome-list">
                <h4>BOHAI University</h4>
                <span>2011 - 2015</span>
                <p>Computer Science and Technology.</p>
              </div>
              <div class="resome-list">
                <h4>Web Developer</h4>
                <span>2014 - Now</span>
                <p>Html5, AngularJS, Vue, Wechat Official Account.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="contact-box">
      <div class="about-container">
        <div class="about-container-head center">
          <h2>Contact Me</h2>
          <p>Welcome to contact us</p>
        </div>
        <div class="about-container-content clearfix">
          <div class="one left">
            <div class="contact-info">
              <div class="icon">
                <img src="../assets/about/contact-icon-1.png" alt="">
              </div>
              <h4 class="m-b-10">Email</h4>
              <p>924934005@qq.com</p>
            </div>
            <div class="contact-info">
              <div class="icon">
                <img src="../assets/about/contact-icon-2.png" alt="">
              </div>
              <h4 class="m-b-10">Location</h4>
              <p>China </p>
            </div>
            <div class="contact-info">
              <div class="icon">
                <img src="../assets/about/contact-icon-3.png" alt="">
              </div>
              <h4 class="m-b-10">Phone</h4>
              <p>186********</p>
            </div>
          </div>
          <div class="three left clearfix">
            <div class="left two">
              <input type="text" placeholder="Enter Name">
            </div>
            <div class="left two">
              <input type="email" placeholder="Enter Email">
            </div>
            <div>
              <input type="text" placeholder="Enter Sujbect">
              <textarea name="message" id="message" cols="30" rows="10" placeholder="Meassage"></textarea>
              <input type="submit" value="Send Message" class="contact-btn">
            </div>
          </div>
        </div>
      </div>
    </section>
    <span class="go-top" @click="goTop">
      <i class="el-icon-d-arrow-right"></i>
    </span>
  </div>
</template>
<script>
import Head from '@/components/Head.vue';

export default {
  name: 'show',
  components: { Head },
  data: function() {
    return {
      addTimer: null,
      cutTimer: null,
      skillList: ['Web Developer','Java Engineer', 'Photography', 'UI/UX Designer'],
      skillIdx: 0,
      content: 'Web Developer',
      count: 0
    };
  },
  mounted() {
    var _this = this;
    _this.count = _this.content.length;
    setTimeout(function(){
      _this.count = 0;
    }, 400);
    _this.initEvent('init');
  },
  beforeDestroy() {
    clearInterval(this.addTimer);
    clearInterval(this.cutTimer);
  },
  methods: {
    initEvent: function(init) {
      var _this = this;
      _this.skillIdx++;
      _this.skillIdx = (_this.skillIdx >= _this.skillList.length) ? 0 : _this.skillIdx;
      _this.skillIdx = init ? 0 : _this.skillIdx;
      _this.content = _this.skillList[_this.skillIdx];
      setTimeout(function(){
        _this.addTag();
        _this.addTimer = setInterval(_this.addTag, 150);
      }, 500);
    },
    addTag: function() {
      var _this = this;
      if (_this.count == _this.content.length) {
        clearInterval(_this.addTimer);
        setTimeout(function(){
          _this.cutTag();
          _this.cutTimer = setInterval(_this.cutTag, 50);
        }, 1000);
      }
      _this.count++;
    },
    cutTag: function() {
      var _this = this;
      if (_this.count == 0) {
        clearInterval(_this.cutTimer);
        _this.initEvent();
      }
      _this.count--;
    },
    goTop: function() {
      var _this = this;
      setTimeout(function(){
        _this.$refs.goTop.$el.scrollIntoView({behavior: 'smooth'})
      },500);
    }
  }
};
</script>
<style>
  @import url("https://fonts.googleapis.com/css?family=Montserrat:400,500,600,700,800,900|Open+Sans:400,600,700");
  .about { font-family: "Open Sans", sans-serif; font-size: 16px; line-height: 1.42857143; color: #222; margin: 0; }
  .about * { box-sizing: border-box; }
  h1,h2,h3,h4,h5,h6 { font-weight: 700; font-family: "Montserrat", sans-serif; }
  h1,h2,h3 { margin-top: 20px; }
  h4,h5,h6 { margin-top: 10px; }
  h1 { font-size: 48px; line-height: 1.0833333333333333; margin-bottom: 0.5416666666666666em; }
  h2 { font-size: 36px; line-height: 1.4444444444444444; }
  h4 { font-size: 21px; line-height: 1.2380952380952381; }
  h6 { font-size: 16px; line-height: 1.625; margin-bottom: 1.625em; }
  input,textarea { line-height: inherit; outline: none; }
  .header-box {
    background-image: url(../assets/about/header-bg-1.jpg);
    position: relative;
    width: 100%;
    height: 100vh;
    background-size: cover;
    background-position: center;
    margin-top: -50px;
    display: table;
    z-index: 1;
  }
  .header-box:after {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: -1;
    content: '';
    opacity: .8;
  }
  .header-box .header-inner {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    color: #fff;
  }
  .header-box h1 {
    color: #fff;
    margin-bottom: 0;
    /*font-size: 80px; responsive.css */
    font-weight: 900;
    font-family: "Montserrat", sans-serif;
  }
  .header-box h6 {
    color: #fff;
    display: inline-block;
  }
  .header-box .typed-cursor {
    font-size: 25px !important;
    font-weight: 300;
    opacity: 1;
    -webkit-animation-duration: 1s;
    -moz-animation-duration: 1s;
    -o-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    -o-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    -webkit-animation-name: blink;
    -moz-animation-name: blink;
    -o-animation-name: blink;
    animation-name: blink;
    -webkit-animation-direction: "";
    -moz-animation-direction: "";
    -o-animation-direction: "";
    animation-direction: "";
  }
  .header-box .scroll-down {
    display: inline-block;
    height: 35px;
    width: 20px;
    border: 2px solid #fff;
    border-radius: 10px;
    position: absolute;
    left: 50%;
    bottom: 30px;
    -ms-transform: translate(-50%, 0);
    /* IE 9 */
    -webkit-transform: translate(-50%, 0);
    /* Chrome, Safari, Opera */
    transform: translate(-50%, 0);
  }
  .header-box .scroll-down span {
    height: 6px;
    width: 4px;
    border-radius: 50%;
    display: inline-block;
    background-color: #fff;
    -webkit-animation-duration: 1s;
    -moz-animation-duration: 1s;
    -o-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    -o-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    -webkit-animation-name: scrollDown;
    -moz-animation-name: scrollDown;
    -o-animation-name: scrollDown;
    animation-name: scrollDown;
    -webkit-animation-direction: ease-in;
    -moz-animation-direction: ease-in;
    -o-animation-direction: ease-in;
    animation-direction: ease-in;
    padding-top: 5px;
    margin-top: 5px;
  }
  @-webkit-keyframes blink {
    0% {
      opacity: 1; }
    50% {
      opacity: 0; }
    100% {
      opacity: 1; }
  }
  @-moz-keyframes blink {
    0% {
      opacity: 1; }
    50% {
      opacity: 0; }
    100% {
      opacity: 1; }
  }
  @-o-keyframes blink {
    0% {
      opacity: 1; }
    50% {
      opacity: 0; }
    100% {
      opacity: 1; }
  }
  @keyframes blink {
    0% {
      opacity: 1; }
    50% {
      opacity: 0; }
    100% {
      opacity: 1; }
  }
  @-webkit-keyframes scrollDown {
    0% {
      opacity: 0.5;
      margin-bottom: 20px; }
    50% {
      opacity: 1;
      margin-bottom: 1px; }
    100% {
      opacity: 0;
      margin-bottom: 0px; }
  }
  @-moz-keyframes scrollDown {
    0% {
      opacity: 0.5;
      margin-bottom: 20px; }
    50% {
      opacity: 1;
      margin-bottom: 1px; }
    100% {
      opacity: 0;
      margin-bottom: 0px; }
  }
  @-o-keyframes scrollDown {
    0% {
      opacity: 0.5;
      margin-bottom: 20px; }
    50% {
      opacity: 1;
      margin-bottom: 1px; }
    100% {
      opacity: 0;
      margin-bottom: 0px; }
  }
  @keyframes scrollDown {
    0% {
      opacity: 0.5;
      margin-bottom: 20px; }
    50% {
      opacity: 1;
      margin-bottom: 1px; }
    100% {
      opacity: 0;
      margin-bottom: 0px; }
  }
  .team-box {
    background-color: #eee;
    padding-top: 67px;
    padding-bottom: 102px;
  }
  .about-container {
    margin-right: auto;
    margin-left: auto;
  }
  .about-container h2 {
    position: relative;
  }
  .about-container h2:before {
    position: absolute;
    left: 50%;
    bottom: -17px;
    width: 200px;
    height: 3px;
    background: #2a2a2a;
    content: '';
    -ms-transform: translate(-50%, 0);
    -webkit-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
  }
  .about-container h2:after {
    width: 15px;
    height: 15px;
    left: 50%;
    bottom: -23px;
    border: 2px solid #ddd;
    position: absolute;
    background: #2a2a2a;
    content: '';
    -ms-transform: translate(-50%, 0) rotate(135deg);
    -webkit-transform: translate(-50%, 0) rotate(135deg);
    transform: translate(-50%, 0) rotate(135deg);
    box-sizing: border-box;
  }
  .about-container p {
    line-height: 1.625;
  }
  .about-container-head p {
    margin-top: 12px;
    margin-bottom: 0;
    padding-top: 37px;
    padding-bottom: 37px;
  }
  .about-container-content > div {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-bottom: 15px;
  }
  .about-container-content > div.one,
  .about-container-content > div.three {
    margin-bottom: 0;
  }
  .about-container-content > div.three > div {
    width: 100%;
  }
  .about-container-content h4 {
    margin-bottom: 2px;
    position: relative;
  }
  .team-member {
    border: 1px solid #e8e3e3;
    box-shadow: 0 13px 59px 0 rgba(132, 141, 178, 0.22);
  }
  .team-member img {
    display: block;
    margin: 0 auto;
  }
  .team-box ul {
    margin-top: 35px;
  }
  .team-box ul li {
    display: inline-block;
    width: 40px;
    height: 40px;
    border: 1px solid #2a2a2a;
    background-color: #2a2a2a;
    line-height: 40px;
    -ms-transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    transform: rotate(135deg);
    margin-right: 10px;
    cursor: pointer;
    -webkit-transition: 0.5s ease-in;
    -moz-transition: 0.5s ease-in;
    transition: 0.5s ease-in;
  }
  .team-box ul li:hover {
    -ms-transform: rotate(0deg);
    /* IE 9 */
    -webkit-transform: rotate(0deg);
    /* Chrome, Safari, Opera */
    transform: rotate(0deg);
  }
  .team-box ul li:hover i {
    -ms-transform: rotate(0deg);
    /* IE 9 */
    -webkit-transform: rotate(0deg);
    /* Chrome, Safari, Opera */
    transform: rotate(0deg);
    color: #fff;
  }
  .team-box ul li a i {
    -ms-transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
    transform: rotate(-135deg);
    color: #fff;
    -webkit-transition: 0.5s ease-in;
    -moz-transition: 0.5s ease-in;
    transition: 0.5s ease-in;
  }
  .resome-box {
    padding-top: 66px;
    padding-bottom: 94px;
  }
  .resome-detail {
    border-left: 2px solid #222;
    position: relative;
    padding-top: 60px;
    padding-left: 30px;
  }
  .resome-detail .icon {
    display: inline-block;
    font-size: 20px;
    border: 1px solid #222;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    transform: rotate(135deg);
    background: #222;
    color: #fff;
    position: absolute;
    left: -21px;
    top: 8px;
  }
  .resome-detail .icon i {
    transform: rotate(-135deg);
    text-align: center;
    line-height: 40px;
    display: inline-block;
  }
  .resome-list {
    padding: 20px;
    box-shadow: 0 0 5px #ddd;
    margin-bottom: 30px;
    border: 1px solid #fff;
    padding-top: 15px;
  }
  .resome-list h4:after {
    position: absolute;
    left: -59px;
    top: 5px;
    width: 15px;
    height: 15px;
    background: #222;
    content: '';
    transform: rotate(135deg);
  }
  .resome-list span {
    font-size: 14px;
    display: block;
    padding-bottom: 20px;
    opacity: .8;
  }
  .contact-box {
    background-color: #eee;
    padding-top: 67px;
    padding-bottom: 70px;
  }
  .contact-info {
    text-align: center;
    border: 1px solid #fff;
    background: #fff;
    box-shadow: 0 0 5px #ddd;
    padding-top: 10px;
    padding-bottom: 13px;
    margin-bottom: 30px;
  }
  .contact-box input[type=text],
  .contact-box input[type=email] {
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 20px;
    width: 100%;
    margin-bottom: 30px;
    font-size: 16px;
  }
  .contact-box textarea {
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 20px;
    width: 100%;
    margin-bottom: 30px;
    font-size: 16px;
  }
  .contact-info img {
    vertical-align: middle;
  }
  .contact-btn {
    width: 180px;
    height: 46px;
    border-radius: 8px;
    margin-top: 11px;
    background: #fff;
    position: relative;
    display: inline-block;
    padding: 10px;
    text-transform: uppercase;
    border: 2px solid #2a2a2a;
    margin-right: 30px;
    font-weight: 600;
    color: #222;
    -webkit-transition: 0.5s ease-in;
    -moz-transition: 0.5s ease-in;
    transition: 0.5s ease-in;
    z-index: 1;
    overflow: hidden;
    text-align: center;
    cursor: pointer;
    font-size: 16px;
  }
  .contact-btn:hover {
    background-color: #2A2A2A;
    color: #fff;
  }
  .go-top {
    position: fixed;
    right: 30px;
    bottom: 30px;
    width: 40px;
    height: 40px;
    background: #000;
    color: #fff;
    line-height: 40px;
    text-align: center;
    -ms-transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    transform: rotate(135deg);
    -webkit-transition: 0.5s ease-in;
    -moz-transition: 0.5s ease-in;
    transition: 0.5s ease-in;
    cursor: pointer;
    border: 2px solid #fff;
  }
  .go-top:hover {
    -ms-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  .go-top i {
    transform: rotate(135deg);
  }
  .go-top:hover i {
    transform: rotate(-90deg);
  }
  @media (min-width: 768px) {
    .about-container {
      width:750px
    }
    .about-container-content .two {
      width: 50%;
    }
    .about-container-content > div.one {
      display: flex;
    }
    .about-container-content > div.one > div {
      min-height: 160px;
      flex: 1;
    }
    .about-container-content > div.one > div:nth-child(2) {
      margin-left: 4px;
      margin-right: 4px;
    }
    .about-container-content > div.one > div p {
      font-size: 85%;
    }
    .about-container-content > div.three {
      width: 100%;
    }
    .about-container-content > div.three .two {
      width: 50%;
    }
    .about-container-content > div.three .two:nth-child(1) {
      padding-right: 15px;
    }
    .about-container-content > div.three .two:nth-child(2) {
      padding-left: 15px;
    }
  }
  @media (min-width: 992px) {
    .about-container {
      width:970px;
    }
    .about-container-head {
      width: 50%;
      margin-left: 25%;
    }
    .about-container-content > div.one {
      width: calc(100% / 3);
      display: inline-block;
    }
    .about-container-content > div.one > div p {
      font-size: 100%;
    }
    .about-container-content > div.three {
      width: calc(100% / 3 * 2);
    }
  }
  @media (min-width: 1200px) {
    .about-container {
      width:1170px
    }
  }
  @media only screen and (max-width: 414px) {
    .resome-detail {
      margin-left: 20px;
    }
  }
</style>
